/**
 * System Set (AAS-1192, reworked AAS-5059) — variant-driven component list.
 *
 * The set components live in the variant metafield pim.components, so they can
 * differ per variant. snippets/system-set.liquid renders every variant's set
 * up-front (only the active one visible); this script swaps the visible block
 * on variant change. Read-only — no selection or add-to-cart.
 *
 * AAS-5059: the detail panel opens on CLICK (was hover-only — dead on touch,
 * annoying on desktop), driving the SAME class choreography the ski-set
 * chooser uses (.ski-set__card--open / --closing + .is-visible on the panel,
 * ski-set-selector.css keyframes), so both widgets share one design codebase.
 * Escape, an outside click, or the pointer leaving the open card close it —
 * mirroring the chooser's close paths.
 *
 * Guarded because the snippet renders twice (desktop + mobile copies), so this
 * file is included on the page more than once.
 */
(function () {
  if (window.__systemSetLoaded) return;
  window.__systemSetLoaded = true;

  // Matches the chooser's close animation (ski-set-pop-close 0.2s) + buffer.
  var CLOSE_MS = 230;
  var closingTimers = new WeakMap();

  function openItem(item) {
    item.classList.remove('ski-set__card--closing');
    item.classList.add('ski-set__card--open');
    item.querySelector('.ski-set__body-popup')?.classList.add('is-visible');
    item.querySelector('.ski-set__trigger')?.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item) {
    if (!item.classList.contains('ski-set__card--open') || closingTimers.has(item)) return;
    item.querySelector('.ski-set__trigger')?.setAttribute('aria-expanded', 'false');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var commit = function () {
      closingTimers.delete(item);
      item.classList.remove('ski-set__card--open', 'ski-set__card--closing');
      item.querySelector('.ski-set__body-popup')?.classList.remove('is-visible');
    };
    if (reduceMotion) {
      commit();
      return;
    }
    item.classList.add('ski-set__card--closing');
    closingTimers.set(item, setTimeout(commit, CLOSE_MS));
  }

  function closeAll(except) {
    document.querySelectorAll('.system-set__item.ski-set__card--open').forEach(function (item) {
      if (item !== except) closeItem(item);
    });
  }

  function bindToggle() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.system-set__item .ski-set__trigger');
      if (trigger) {
        var item = trigger.closest('.system-set__item');
        var isOpen = item.classList.contains('ski-set__card--open');
        closeAll(item);
        if (isOpen) closeItem(item);
        else openItem(item);
        return;
      }
      // Outside click closes (clicks inside the open panel — e.g. the info
      // link — pass through untouched).
      if (!e.target.closest('.system-set__item')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest('.system-set__item .ski-set__trigger');
      if (!trigger) return;
      e.preventDefault();
      trigger.click();
    });

    // Desktop parity with the chooser: the pointer leaving the open card
    // closes it (touch keeps the outside-click close instead).
    document.addEventListener('pointerout', function (e) {
      if (e.pointerType === 'touch') return;
      var openCard = e.target.closest('.system-set__item.ski-set__card--open');
      if (openCard && !openCard.contains(e.relatedTarget)) closeItem(openCard);
    });
  }

  // Show the block for `variantId` in every system-set instance (desktop + mobile);
  // hide all others. Variants without components have no block, so nothing shows.
  function showVariant(variantId) {
    const id = String(variantId);
    document.querySelectorAll('[data-system-set]').forEach((root) => {
      root.querySelectorAll('.system-set__variant').forEach((block) => {
        block.hidden = String(block.dataset.variantId) !== id;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('[data-system-set]')) return;

    bindToggle();

    const variantSelects = document.querySelector('variant-selects');

    // Initial sync — the deep-linked ?variant= may differ from the server's
    // selected_or_first_available_variant used at render time.
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) {
      showVariant(urlVariantId);
    } else if (variantSelects?.currentVariant) {
      showVariant(variantSelects.currentVariant.id);
    }

    // Live sync — fires as soon as VariantSelects updates currentVariant.
    variantSelects?.addEventListener('change', () => {
      if (variantSelects.currentVariant) showVariant(variantSelects.currentVariant.id);
    });

    // Post-render confirmation via pub/sub.
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event.data?.variant;
        if (variant) showVariant(variant.id);
      });
    }
  });
})();
